import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { toast } from "react-toastify";
import { useEffect, useRef } from "react";

export default function PermissionCheck() {
    const { permissions, isLoading } = useAuth();
    const location = useLocation();
    const path = location.pathname;
    const hasShownToast = useRef(false);

    // Define required permissions for specific routes
    const routePermissions = {
        '/users': 'users.view',
        '/': 'dashboard.view',
        '/employees': 'employees.view',
    };

    const requiredPermission = routePermissions[path];
    const hasPermission = !requiredPermission || permissions.includes(requiredPermission);

    useEffect(() => {
        if (!hasPermission && !hasShownToast.current && !isLoading) {
            const toastId = 'permission-error';
            if (!toast.isActive(toastId)) {
                toast.error("You do not have permission to access this page.", { toastId });
            }
            hasShownToast.current = true;
        }
        
        // Reset the flag when the path changes
        return () => {
            hasShownToast.current = false;
        };
    }, [hasPermission, path, isLoading]);

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!hasPermission) {
        return <Navigate to="/" replace />
    }
    return <Outlet />
}